<section id="manageEmailContainer">
  <form id="manageEmailForm" [formGroup]="emailPrefsForm" (ngSubmit)="submitForm()">
    <header class="modal-header" zbpZbSwirl>
      <h4 class="modal-title text-uppercase">MANAGE USER'S EMAIL NOTIFICATION</h4>
      <button type="button" class="btn close" aria-label="Close" (click)="dismiss()">
        <i class="fa fa-xmark" aria-hidden="true"></i>
      </button>
    </header>
    <div class="modal-body">
      <div class="mb-3 mt-2">
        <input type="checkbox" formControlName="oneRosterFiles" class="form-check-input form-control-tertiary ms-4" id="oneRosterFilesChkBox"/>
        <label for="oneRosterFiles" class="form-check-label ms-2">OneRoster files placed</label>
      </div>
      <div class="mb-3">
        <input type="checkbox" formControlName="oneRosterErrors" class="form-check-input form-control-tertiary ms-4" id="oneRosterErrorsChkBox"/>
        <label for="oneRosterErrorsChkBox" class="form-check-label ms-2">OneRoster critical errors received</label>
      </div>
      <div class="mb-3">
        <input type="checkbox" formControlName="turnOffDashboard" class="form-check-input form-control-tertiary ms-4" id="oneRosterErrorsChkBox"/>
        <label for="oneRosterErrorsChkBox" class="form-check-label ms-2">Requests to turn off the integration dashboard</label>
      </div>
    </div>
    <div class="modal-footer">
      <button id="cancelEmailPrefsBtn" class="btn btn-outline-tertiary text-uppercase btn-sm" (click)="dismiss()">Cancel</button>
      <button id="saveEmailPrefsBtn" type="submit" class="btn btn-tertiary text-uppercase btn-sm">Save</button>
    </div>
  </form>
</section>
